<template>
  <div>
    <v-layout column v-if="shopLoad" align-center>
      <!--
        <v-progress-circular style="margin-top:100px" color="red lighten-3" size="64" indeterminate></v-progress-circular>
      -->
      <progress-q></progress-q>
    </v-layout>
    <modal-q v-if="isLoading"></modal-q>
    <dialog-images
      v-if="dialogChangeIcon"
      :images="priceImages"
      :shop-id="shopID"
      :token="$store.getters.token"
      @close-dialog="() => (this.dialogChangeIcon = false)"
      @click-image="(item) => loadImage(item)"
      @image-uploaded="onImageUploaded"
    />
    <v-layout row wrap>
      <v-flex xs12 sm12 md12 lg12>
        <v-card v-if="!shopLoad" style="display: flex; flex-direction: column;">
          <v-toolbar class="q-orange-bk q-text-whitesmoke" height="50px">
            <v-toolbar-title>{{ getString("Servizi") }}</v-toolbar-title>
          </v-toolbar>
          <div style="border-radius: 0; padding: 10px">
            <label>Nota per i clienti sui servizi</label>
            <v-textarea
              v-model="shop.serviceNote"
              solo
              counter
              maxlength="500"
              label="Nota per i clienti"
              @blur="setShop"
            ></v-textarea>
            <!-- <div class="center">
              <v-btn
                class="q-orange-bk q-text-whitesmoke"
                :class="{ 'save-alert': saveAlert }"
                @click="setShop"
                >{{ getString("Salva") }}</v-btn
              >
            </div> -->
          </div>

          <v-card-text style="flex: 1; overflow-y: auto;">
            <v-layout
              row
              wrap
              style="border: 1px solid; border-radius: 2px; padding: 5px"
              ma-3
            >
              <v-flex xs12>
                <h3>
                  {{ getString("Inserisci un nuovo servizio") }}
                </h3>
              </v-flex>
              <v-flex grow>
                <v-layout class="formDesc" row wrap>
                  <v-flex xs12 lg2 ma-2>
                    <label>{{ getString("Seleziona categoria") }}</label>
                    <v-select
                      solo
                      item-text="name"
                      item-value="idPriceCategory"
                      v-model="selCategory"
                      :items="[
                        { name: 'Nessuna categoria', idPriceCategory: null },
                        ...categories,
                      ]"
                      label="Seleziona la categoria"
                      :menu-props="{ bottom: true, offsetY: true }"
                      ><template slot="append">
                        
                        <v-btn icon @click.stop="showAddCategoryDialog = true" @mousedown.stop>
                          <v-icon
                            style="cursor: pointer"
                            class="q-orange"
                            size="30"
                            >add_box</v-icon
                          >
                        </v-btn>
                      </template>
                    </v-select>
                  </v-flex>
                  <v-flex shrink ma-2 style="height: 97px">
                    <label>{{ getString("Icona") }}</label>
                    <div class="desc, center">
                      <button
                        class="icon-button"
                        @click="changeIcon(currentElementiIconPicked)"
                      >
                        <v-img :src="currentElementiIconPicked.image" />
                      </button>
                    </div>
                  </v-flex>
                  <v-flex grow ma-2>
                    <label>{{ getString("Nome servizio") }}</label>
                    <v-text-field
                      v-model="priceName"
                      solo
                      :label="getString('Es. Barba')"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs5 lg2 ma-2>
                    <label>{{ getString("Prezzo") }}</label>
                    <v-text-field
                      v-model="pricePrice"
                      solo
                      maxlength="15"
                      counter
                      :label="getString('Es. 10€')"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs5 lg1 ma-2>
                    <label>{{ getString("Minuti") }}</label>
                    <v-text-field
                      v-model="priceTime"
                      :rules="tenMinRule"
                      solo
                      :label="getString('Es. 20')"
                      :hint="getString('Minimo 10 min.')"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 lg12 ma-2>
                    <label>{{
                      getString("Descrizione completa (facoltativa)")
                    }}</label>
                     <v-textarea
                     auto-grow
                     rows="2"
                      v-model="priceDescription"
                      solo
                      :label="getString('')"
                    ></v-textarea>
                  </v-flex>
                  <v-flex xs12 style="text-align: center">
                    <v-btn
                      @click="addPrice"
                      class="q-orange-bk q-text-whitesmoke"
                    >
                      Salva
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12>
                <span
                  >Ricorda di associare il servizio appena creato ad un
                  collaboratore nella sezione <b>DIPENDENTI</b></span
                >
              </v-flex>
            </v-layout>
            <v-card style="border-radius: 0; margin: 2px 20px" class="hidden-sm-and-down">
                  <v-toolbar style="background: var(--background-full)">
                    <div class="pricesElements">
                      <span style="width: 50px; padding-left: 0">{{
                        getString("Sposta")
                      }}</span>
                      <span style="width: 50px" flat>{{
                        getString("Icona")
                      }}</span>
                      <span class="desc" flat>{{ getString("Nome") }}</span>
                      <span class="fulldesc" flat>{{
                        getString("Descrizione")
                      }}</span>
                      <span style="width: 150px" flat>{{
                        getString("Tempo")
                      }}</span>
                      <span style="width: 100px" flat>{{
                        getString("Prezzo")
                      }}</span>
                      <span style="width: 120px" flat>{{
                        getString("Rimuovi")
                      }}</span>
                    </div>
                  </v-toolbar>
                </v-card>
            <draggable
              v-model="prices"
              :options="sortOptions"
              @update="updateSort"
            >
              <div v-for="(element, index) in prices" :key="element.idPrice">
                <v-card
                  style="border-radius: 0; margin: 2px 20px"
                  class="hidden-sm-and-down"
                  v-if="
                    element.referencePriceCategory === null ||
                    element.referencePriceCategory === 0 ||
                    !categories.some(
                      (cat) =>
                        cat.idPriceCategory === element.referencePriceCategory
                    )
                  "
                >
                  <v-toolbar
                    style="
                      paddding-right: 0;
                      background: var(--background-full);
                    "
                  >
                    <v-toolbar-items>
                      <v-icon
                        class="handle"
                        :class="{ 'd-none': isLoading }"
                        style="cursor: move; margin-right: 30px"
                        >format_line_spacing</v-icon
                      >
                    </v-toolbar-items>
                    <span style="display: none">{{
                      (element.sort = index)
                    }}</span>
                    <div class="pricesElements">
                      <span v-if="!editTime" class="center" flat>
                        <v-img
                          height="30"
                          width="30"
                          :src="element.image"
                          :class="isCustomPhoto(element.image) ? '' : 'icon-color'"
                        />
                      </span>
                      <span v-if="editTime" class="desc, center"
                        ><button
                          class="icon-button"
                          @click="changeIcon(element)"
                        >
                          <v-img :src="element.image" /></button
                      ></span>

                      <span v-if="!editTime" class="desc" flat>{{
                        element.description
                      }}</span>

                      <v-text-field
                        v-if="editTime"
                        class="desc edit-field"
                        v-model="element.description"
                        outlined
                        dense
                        hide-details
                        :placeholder="getString('Nome servizio')"
                      />

                      <span v-if="!editTime" class="fulldesc" flat>{{
                        element.fullDescription
                      }}</span>
                      <v-text-field
                        v-if="editTime"
                        class="fulldesc edit-field"
                        v-model="element.fullDescription"
                        outlined
                        dense
                        hide-details
                        :placeholder="getString('Descrizione')"
                      />

                      <span style="width: 100px" flat v-if="!editTime"
                        >{{ element.timeInMinute }}&nbsp;{{
                          getString("min")
                        }}</span
                      >
                      <v-text-field
                        v-if="editTime"
                        class="edit-field"
                        style="width: 100px"
                        v-model="element.timeInMinute"
                        outlined
                        dense
                        hide-details
                        :label="getString('Min')"
                        :placeholder="getString('Min')"
                      />

                      <span v-if="!editTime" style="width: 100px" flat>{{
                        element.price
                      }}</span>
                      <v-text-field
                        v-if="editTime"
                        class="edit-field"
                        style="width: 100px"
                        v-model="element.price"
                        outlined
                        dense
                        hide-details
                        maxlength="15"
                        :label="getString('Prezzo')"
                        :placeholder="getString('Prezzo')"
                      />
                      <span style="width: 120px" class="center">
                        <v-icon
                          class="q-danger-bk"
                          @click="removePrice(element, $event)"
                          >remove_circle</v-icon
                        >
                      </span>
                    </div>
                  </v-toolbar>
                </v-card>
                <v-card
                  v-if="
                    element.referencePriceCategory === null ||
                    element.referencePriceCategory === 0 ||
                    !categories.some(
                      (cat) =>
                        cat.idPriceCategory === element.referencePriceCategory
                    )
                  "
                  class="hidden-md-and-up service-mobile-card"
                  style="margin: 4px 8px; border-radius: 4px"
                >
                  <v-card-text class="py-2">
                    <div class="service-mobile__row">
                      <v-icon
                        class="handle service-mobile__handle"
                        :class="{ 'd-none': isLoading }"
                        >drag_handle</v-icon
                      >
                      <div v-if="!editTime" class="service-mobile__icon-wrap">
                        <v-img
                          :src="element.image"
                          :class="isCustomPhoto(element.image) ? '' : 'icon-color'"
                          contain
                        />
                      </div>
                      <button
                        v-if="editTime"
                        class="icon-button"
                        style="flex-shrink: 0; width: 36px; height: 36px;;"
                        @click="changeIcon(element)"
                      >
                        <v-img :src="element.image" contain />
                      </button>
                      <div class="service-mobile__info">
                        <div v-if="!editTime" class="service-mobile__name">{{ element.description }}</div>
                        <v-text-field
                          v-if="editTime"
                          v-model="element.description"
                          outlined
                          dense
                          hide-details
                          class="edit-field"
                          :placeholder="getString('Nome servizio')"
                        />
                        <div
                          v-if="!editTime && element.fullDescription"
                          class="service-mobile__fulldesc"
                        >{{ element.fullDescription }}</div>
                        <v-text-field
                          v-if="editTime"
                          v-model="element.fullDescription"
                          outlined
                          dense
                          hide-details
                          class="edit-field"
                          style="margin-top: 4px"
                          :placeholder="getString('Descrizione')"
                        />
                      </div>
                      <v-icon
                        class="q-danger-bk"
                        style="flex-shrink: 0"
                        @click="removePrice(element, $event)"
                        >remove_circle</v-icon
                      >
                    </div>
                    <div class="service-mobile__footer">
                      <span v-if="!editTime" class="service-mobile__meta"
                        >{{ element.timeInMinute }} {{ getString('min') }} · {{ element.price }}</span
                      >
                      <template v-if="editTime">
                        <v-text-field
                          v-model="element.timeInMinute"
                          outlined
                          dense
                          hide-details
                          :placeholder="getString('Min')"
                           :label="getString('Durata')"
                          class="service-mobile__input"
                        />
                        <v-text-field
                          v-model="element.price"
                          outlined
                          dense
                          hide-details
                          maxlength="15"
                           :label="getString('Prezzo')"
                          :placeholder="getString('Prezzo')"
                          class="service-mobile__input"
                        />
                      </template>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </draggable>
            <draggable
              v-model="categories"
              :options="sortOptions"
              @update="categoriesSort"
            >
              <div
                v-for="(category, index) in categories"
                :key="category.idPriceCategory"
              >
                <v-card style="border-radius: 0; margin: 10px 2px">
                  <v-toolbar
                    style="
                      paddding-right: 0;
                      background: var(--background-full);
                    "
                    class="q-orange-bk q-text-whitesmoke"
                  >
                    <v-toolbar-items>
                      <v-icon
                        class="handle q-text-whitesmoke"
                        :class="{ 'd-none': isLoading }"
                        style="cursor: move; margin-right: 30px"
                        >format_line_spacing</v-icon
                      >
                    </v-toolbar-items>
                    <span style="display: none">{{
                      (category.sort = index)
                    }}</span>
                    <div class="pricesElements">
                      <span v-if="!editTime" class="center" flat>
                        <v-img
                          height="30"
                          width="30"
                          :src="category.image"
                          :class="isCustomPhoto(category.image) ? '' : 'icon-color'"
                          :style="isCustomPhoto(category.image) ? {} : { filter: 'brightness(0) invert(1)' }"
                        />
                      </span>
                      <span v-if="editTime" class="desc, center"
                        ><button
                          class="icon-button"
                          @click="changeIcon(category)"
                        >
                          <v-img :src="category.image" /></button
                      ></span>

                      <span v-if="!editTime" class="desc" flat>{{
                        category.name
                      }}</span>
                      <v-text-field
                        v-if="editTime"
                        class="desc"
                        v-model="category.name"
                      />

                      <span style="width: 120px" class="center">
                        <v-icon
                          class="q-danger-bk q-text-whitesmoke"
                          @click="removeCategory(category, $event)"
                          >remove_circle</v-icon
                        >
                      </span>
                    </div>
                  </v-toolbar>
                </v-card>
                <v-card style="border-radius: 0; margin: 2px 20px" class="hidden-sm-and-down">
                  <v-toolbar style="background: var(--background-full)">
                    <div class="pricesElements">
                      <span style="width: 50px; padding-left: 0">{{
                        getString("Sposta")
                      }}</span>
                      <span style="width: 50px" flat>{{
                        getString("Icona")
                      }}</span>
                      <span class="desc" flat>{{ getString("Nome") }}</span>
                      <span class="fulldesc" flat>{{
                        getString("Descrizione")
                      }}</span>
                      <span style="width: 150px" flat>{{
                        getString("Tempo")
                      }}</span>
                      <span style="width: 100px" flat>{{
                        getString("Prezzo")
                      }}</span>
                      <span style="width: 120px" flat>{{
                        getString("Rimuovi")
                      }}</span>
                    </div>
                  </v-toolbar>
                </v-card>
                <draggable
                  v-model="prices"
                  :options="sortOptions"
                  @update="updateSort"
                >
                  <div
                    v-for="(element, index) in prices"
                    :key="element.idPrice"
                  >
                    <v-card
                      style="border-radius: 0; margin: 2px 20px"
                      class="hidden-sm-and-down"
                      v-if="
                        element.referencePriceCategory ===
                        category.idPriceCategory
                      "
                    >
                      <v-toolbar
                        style="
                          paddding-right: 0;
                          background: var(--background-full);
                        "
                      >
                        <v-toolbar-items>
                          <v-icon
                            class="handle"
                            :class="{ 'd-none': isLoading }"
                            style="cursor: move; margin-right: 30px"
                            >format_line_spacing</v-icon
                          >
                        </v-toolbar-items>
                        <span style="display: none">{{
                          (element.sort = index)
                        }}</span>
                        <div class="pricesElements">
                          <span v-if="!editTime" class="center" flat>
                            <v-img
                              height="30"
                              width="30"
                              :src="element.image"
                              :class="isCustomPhoto(element.image) ? '' : 'icon-color'"
                            />
                          </span>
                          <span v-if="editTime" class="desc, center"
                            ><button
                              class="icon-button"
                              @click="changeIcon(element)"
                            >
                              <v-img :src="element.image" /></button
                          ></span>

                          <span v-if="!editTime" class="desc" flat>{{
                            element.description
                          }}</span>
                          <v-text-field
                            v-if="editTime"
                            class="desc edit-field"
                            v-model="element.description"
                            outlined
                            dense
                            hide-details
                            :placeholder="getString('Nome servizio')"
                          />

                          <span v-if="!editTime" class="fulldesc" flat>{{
                            element.fullDescription
                          }}</span>
                          <v-text-field
                            v-if="editTime"
                            class="fulldesc edit-field"
                            v-model="element.fullDescription"
                            outlined
                            dense
                            hide-details
                            :placeholder="getString('Descrizione')"
                          />

                          <span style="width: 100px" flat v-if="!editTime"
                            >{{ element.timeInMinute }}&nbsp;{{
                              getString("min")
                            }}</span
                          >
                          <v-text-field
                            v-if="editTime"
                            class="edit-field"
                            style="width: 100px"
                            v-model="element.timeInMinute"
                            outlined
                            dense
                            hide-details
                            :label="getString('Min')"
                            :placeholder="getString('Min')"
                          />

                          <span v-if="!editTime" style="width: 100px" flat>{{
                            element.price
                          }}</span>
                          <v-text-field
                            v-if="editTime"
                            class="edit-field"
                            style="width: 100px"
                            v-model="element.price"
                            outlined
                            dense
                            hide-details
                            maxlength="15"
                            :label="getString('Prezzo')"
                            :placeholder="getString('Prezzo')"
                          />
                          <span style="width: 120px" class="center">
                            <v-icon
                              class="q-danger-bk"
                              @click="removePrice(element, $event)"
                              >remove_circle</v-icon
                            >
                          </span>
                        </div>
                      </v-toolbar>
                    </v-card>
                    <v-card
                      v-if="
                        element.referencePriceCategory ===
                        category.idPriceCategory
                      "
                      class="hidden-md-and-up service-mobile-card"
                      style="margin: 4px 8px; border-radius: 4px"
                    >
                      <v-card-text class="py-2">
                        <div class="service-mobile__row">
                          <v-icon
                            class="handle service-mobile__handle"
                            :class="{ 'd-none': isLoading }"
                            >drag_handle</v-icon
                          >
                          <div v-if="!editTime" class="service-mobile__icon-wrap">
                            <v-img
                              :src="element.image"
                              :class="isCustomPhoto(element.image) ? '' : 'icon-color'"
                              contain
                            />
                          </div>
                          <button
                            v-if="editTime"
                            class="icon-button"
                            style="flex-shrink: 0; width: 36px; height: 36px"
                            @click="changeIcon(element)"
                          >
                            <v-img :src="element.image" contain />
                          </button>
                          <div class="service-mobile__info">
                            <div v-if="!editTime" class="service-mobile__name">{{ element.description }}</div>
                            <v-text-field
                              v-if="editTime"
                              v-model="element.description"
                              outlined
                              dense
                              hide-details
                              class="edit-field"
                              :placeholder="getString('Nome servizio')"
                            />
                            <div
                              v-if="!editTime && element.fullDescription"
                              class="service-mobile__fulldesc"
                            >{{ element.fullDescription }}</div>
                            <v-text-field
                              v-if="editTime"
                              v-model="element.fullDescription"
                              outlined
                              dense
                              hide-details
                              class="edit-field"
                              style="margin-top: 4px"
                              :placeholder="getString('Descrizione')"
                            />
                          </div>
                          <v-icon
                            class="q-danger-bk"
                            style="flex-shrink: 0"
                            @click="removePrice(element, $event)"
                            >remove_circle</v-icon
                          >
                        </div>
                        <div class="service-mobile__footer">
                          <span v-if="!editTime" class="service-mobile__meta"
                            >{{ element.timeInMinute }} {{ getString('min') }} · {{ element.price }}</span
                          >
                          <template v-if="editTime">
                            <v-text-field
                              v-model="element.timeInMinute"
                              outlined
                              dense
                              hide-details
                              :placeholder="getString('Min')"
                               :label="getString('Durata')"
                              class="service-mobile__input"
                            />
                            <v-text-field
                              v-model="element.price"
                              outlined
                              dense
                              hide-details
                              maxlength="15"
                               :label="getString('Prezzo')"
                              :placeholder="getString('Prezzo')"
                              class="service-mobile__input"
                            />
                          </template>
                        </div>
                      </v-card-text>
                    </v-card>
                  </div>
                </draggable>
              </div>
            </draggable>
          </v-card-text>
          <div class="center" style="flex-shrink: 0; padding: 8px; border-top: 1px solid #e0e0e0; position: sticky; bottom: 30px; background: var(--background-full); z-index: 1;">
            <v-btn v-if="!editTime" class="q-orange" @click="editTime = true">
              <v-icon>edit</v-icon>Modifica servizi
            </v-btn>
            <v-btn v-if="editTime" class="q-orange" @click="updatePrice">
              <span>Salva</span>
            </v-btn>
            <v-btn v-if="editTime" class="q-orange" @click="resetPrice">
              <span>Annulla</span>
            </v-btn>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="qrcodeDialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>{{
          getString("QrCode App")
        }}</v-card-title>
        <v-card-text>
          <p>
            {{
              getString(
                "Apri l'app QuickBe Cal e riprendi questo qrcode per effettuare il login"
              )
            }}
          </p>
          <div class="text-center">
            <vue-qr :size="400" :text="token"></vue-qr>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn class="q-orange" flat @click="qrcodeDialog = false">{{
            getString("Chiudi")
          }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showAddCategoryDialog" max-width="600" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{
            getString("Inserisci una nuova categoria")
          }}</span>
        </v-card-title>
        <v-card-text>
          <v-layout class="formDesc" row wrap>
            <v-flex shrink ma-2 style="height: 97px">
              <label>{{ getString("Icona") }}</label>
              <div class="desc, center">
                <button
                  class="icon-button"
                  @click="changeIcon(currentElementiIconPickedCat)"
                >
                  <v-img :src="currentElementiIconPickedCat.image" />
                </button>
              </div>
            </v-flex>
            <v-flex grow>
              <label>{{ getString("Nome categoria") }}</label>
              <v-text-field
                v-model="categoryName"
                solo
                :label="getString('Es. Estetista')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 style="text-align: center">
              <v-btn @click="addCategory" class="q-orange-bk q-text-whitesmoke">
                Salva
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showAddCategoryDialog = false">Chiudi</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmDeleteDialog" max-width="450" persistent>
      <v-card>
        <v-card-title class="headline">
          <v-icon color="red" class="mr-2">warning</v-icon>
          {{ getString("Attenzione") }}
        </v-card-title>
        <v-card-text>
          {{ getString("Attenzione, stai per cancellare un servizio, l'operazione è irreversibile") }}
        </v-card-text>
        <v-card-actions>
          <v-btn flat @click="cancelRemovePrice">{{ getString("Annulla") }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn flat class="q-danger q-text-whitesmoke" @click="confirmRemovePrice">{{ getString("Conferma") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--
      <modal v-show="confirmDelete" @click="confirmDelete = false;">
        <v-card-title class="no-padding" slot="header">
          <v-toolbar color="red darken-2" style="text-align:center">
            <span class="headline q-text-whitesmoke text-center">{{
              getString("Conferma cancellazione")
            }}</span>
          </v-toolbar>
        </v-card-title>
        <v-card-text slot="body">
          <v-layout wrap>
            <p>
              {{
                getString(
                  "La cancellazione del servizio è irreversibile Confermi?"
                )
              }}
            </p>
          </v-layout>
          <v-progress-linear
            indeterminate
            v-show="isLoading"
            :active="isLoading"
            :height="2"
          ></v-progress-linear>
        </v-card-text>
        <v-card-actions slot="footer">
          <v-btn
            class="q-orange"
            flat
            :disabled="isLoading"
            @click.native="confirmDelete = false;"
            >{{ getString("No") }}</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            flat
            class="q-orange-bk q-text-whitesmoke"
            :disabled="isLoading"
            @click.native="deleteReservation"
            >{{ getString("Conferma") }}</v-btn
          >
        </v-card-actions>
      </modal>
    -->
  </div>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
import Utils from "../../../utils.js";
import ajax from "../../../ajax.js";
import ProgressQ from "../ProgressQ";
import ModalQ from "../../utils/ModalQ";
import DialogImages from "../../utils/DialogImages";
import draggable from "vuedraggable";
import myUpload from "vue-image-crop-upload";
import ImageCompressor from "image-compressor.js";
import Moment from "moment";
import VueQr from "vue-qr";

var ut = new Utils();
export default {
  name: "ShopDesc",
  props: ["shopID", "tab"],
  components: {
    draggable,
    ProgressQ,
    DialogImages,
    ModalQ,
    VueQr,
    "my-upload": myUpload,
    editor: Editor,
  },
  mounted: function () {
    this.getShop();
    this.getPrices();
    this.getPricesImages();
  },
  computed: {
    token: function () {
      return this.$store.getters.token;
    },
    tenMinRule: function () {
      return [
        (v) => Number.parseInt(v) >= 10 || this.getString("Minimo 10 minuti"),
      ];
    },
    expiredDate: function () {
      return new Moment(this.shop.expired).locale("it").format("DD MMMM YYYY");
    },
    maxSort: function () {
      let max = 0;
      this.prices.forEach((element) => {
        if (element.sort > max) max = element.sort;
      });
      return max;
    },
    pwdConfirmRule: function () {
      return [
        (v) => v === this.pwd || this.getString("Le password non coincidono"),
      ];
    },
    minLenghtRule: function () {
      return [
        (v) =>
          v == undefined ||
          v == "" ||
          ut.MinLengthValidate(v, 8) ||
          this.getString("Password troppo corta, almeno 8 caratteri"),
      ];
    },
    notEmpty: function () {
      return [(v) => !!v || this.getString("Campo richiesto")];
    },
    urlRule: function () {
      return [
        (v) =>
          v == "" ||
          v == null ||
          ut.validateUrl(v) ||
          this.getString("Url non valido"),
      ];
    },
    emailRule: function () {
      return [
        (v) => !!v || this.getString("Campo richiesto"),
        (v) => ut.ValidateEmail(v) || this.getString("Email non valida"),
      ];
    },
    numRule: function () {
      return [
        (v) => !!v || this.getString("Campo richiesto"),
        (v) => ut.ValidateNumber(v) || this.getString("Numero non valido"),
      ];
    },
    saveAlert: function () {
      if (this.tab !== 1) return false;
      let val = this.shop.serviceNote !== this.oldShop.serviceNote;
      if (val && !this.$store.state.modifying) {
        this.$store.commit("isModifying");
      }
      if (!val && this.$store.state.modifying) {
        this.$store.commit("notIsModifying");
      }
      return val;
    },
    defaultAvatar: function () {
      if (
        this.shop.imageLink === null ||
        this.shop.imageLink === "/images/shopdefault.png" ||
        this.shop.imageLink === "images/shopdefault.png"
      ) {
        return "../../../static/img/shopdefault.png";
      } else
        return (
          ajax.baseUrl() + this.shop.imageLink + "?t=" + new Date().getSeconds()
        );
    },
    shopLoad: function () {
      return this.shop.name === null;
    },
    sortOptions: function () {
      return {
        handle: ".handle",
      };
    },

    sortOrder: function () {
      let temp = [];
      let i = 0;
      this.prices.forEach((e) => {
        temp[i++] = e.sort;
      });
      return temp;
    },
  },
  data: () => {
    return {
      h: null,
      show: false,
      showLogoUpload: false,
      hidden: false,
      editTime: false,
      dialogChangeIcon: false,
      currentElementiIconPickedDef: { image: "" },
      currentElementiIconPicked: { image: "" },
      currentElementiIconPickedCat: { image: "" },
      qrcodeDialog: false,
      image: null,
      logo: null,
      imageName: "",
      logoName: "",
      fileUploadProgress: 0,
      isLoading: false,
      isUploading: false,
      priceImage: null,
      priceName: null,
      priceTime: null,
      priceDescription: "",
      pricePrice: null,
      selCategory: null,
      categoryName: null,
      categoryImage: [],
      priceImages: [],
      shop: {
        name: null,
        serviceNote: null,
      },
      oldShop: {
        name: "",
        serviceNote: "",
      },
      prices: [],
      categories: [],
      showAddCategoryDialog: false,
      confirmDeleteDialog: false,
      pendingDeleteItem: null,
      pendingDeleteEvent: null,
    };
  },
  watch: {
    shopID: function () {
      if (this.shopID > 0) {
        this.getShop();
        this.getPrices();
      }
    },
  },
  methods: {
    isCustomPhoto(url) {
      return url && url.includes('/images/shops/');
    },
    // changeIconNew: function (element) {
    //   this.currentElementiIconPickedNew = element;
    //   this.dialogChangeIcon = true;
    // },
    // changeIconCatNew: function (element) {
    //   this.currentElementiIconPickedCatNew = element;
    //   this.dialogChangeIcon = true;
    // },
    changeIcon: function (element) {
      this.currentElementiIconPickedDef = element;
      this.dialogChangeIcon = true;
    },
    loadImage: function (item) {
      this.currentElementiIconPickedDef.image = item.path;
    },
    onImageUploaded: function (imageItem) {
      this.priceImages = [...this.priceImages, imageItem];
    },
    getPricesImages: function () {
      let self = this;
      ajax.axios
        .get(ajax.baseUrl() + "/admin/shops/prices/images?shopId=" + self.shopID, {
          headers: {
            Authorization: "Bearer " + self.$store.getters.token,
          },
          withCredentials: true,
        })
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.priceImages = response.data.data.images;
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    addCategory: function () {
      let data = {
        categoryName: this.categoryName.trim(),
        categoryImage: this.currentElementiIconPickedCat.image,
      };
      let self = this;
      this.isLoading = true
      ajax.axios
        .post(
          ajax.baseUrl() + "/admin/shops/shop/" + self.shopID + "/category/new",
          data,
          {
            headers: {
              Authorization: "Bearer " + self.$store.getters.token,
            },
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.$emit("siteAlertSuccess", response.data.data.text);
          self.categories = response.data.data.categories;
          self.categoryName = null;
          self.currentElementiIconPickedCat.image = "";
          self.showAddCategoryDialog = false;
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        })
        .finally(() => {
          self.isLoading = false;
        });
    },
    addPrice: function () {
      if (this.priceName === null || this.priceName.trim() === "") {
        this.$emit("siteAlert", this.getString("Nome servizio obbligatorio"));
        return;
      }
      if (this.priceTime === null || this.priceTime.trim() === "") {
        this.$emit("siteAlert", this.getString("Tempo obbligatorio"));
        return;
      }
      if (this.pricePrice === null || this.pricePrice.trim() === "") {
        this.$emit("siteAlert", this.getString("Prezzo obbligatorio"));
        return;
      }
      let data = {
        priceName: this.priceName.trim(),
        priceTime: this.priceTime.trim(),
        pricePrice: this.pricePrice.trim(),
        priceImage: this.currentElementiIconPicked.image,
        priceFullDescription: this.priceDescription.trim(),
        categoryId: this.selCategory,
      };
      let self = this;
      this.isLoading = true
      ajax.axios
        .put(
          ajax.baseUrl() + "/admin/shops/shop/" + self.shopID + "/prices/new",
          data,
          {
            headers: {
              Authorization: "Bearer " + self.$store.getters.token,
            },
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.$emit("siteAlertSuccess", response.data.data.text);
          self.prices = response.data.data.prices;
          self.priceName = null;
          self.priceTime = null;
          self.pricePrice = null;
          self.currentElementiIconPicked.image = "";
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        })
        .finally(() => {
          self.isLoading = false;
        });
    },
    removeCategory: function (item, ele) {
      let self = this;
      this.isLoading = true
      ele.currentTarget.disabled = true;
      if (self.shopID > 0) {
        ajax.axios
          .delete(
            ajax.baseUrl() +
              "/admin/shops/shop/" +
              self.shopID +
              "/categories/" +
              item.idPriceCategory,
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true,
            }
          )
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            self.$emit(
              "siteAlertSuccess",
              self.getString("Categoria eliminato.")
            );
            self.categories = response.data.data.categories;
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
            ele.currentTarget.disabled = false;
          })
          .finally(() => {
            self.isLoading = false;
          });
      }
    },
    removePrice: function (item, ele) {
      ele.currentTarget.disabled = true;
      this.pendingDeleteItem = item;
      this.pendingDeleteEvent = ele;
      this.confirmDeleteDialog = true;
    },
    cancelRemovePrice: function () {
      this.confirmDeleteDialog = false;
      if (this.pendingDeleteEvent) {
        this.pendingDeleteEvent.currentTarget.disabled = false;
      }
      this.pendingDeleteItem = null;
      this.pendingDeleteEvent = null;
    },
    confirmRemovePrice: function () {
      this.confirmDeleteDialog = false;
      let item = this.pendingDeleteItem;
      this.pendingDeleteItem = null;
      this.pendingDeleteEvent = null;
      let self = this;
      this.isLoading = true;
      if (self.shopID > 0) {
        ajax.axios
          .delete(
            ajax.baseUrl() +
              "/admin/shops/shop/" +
              self.shopID +
              "/prices/" +
              item.idPrice,
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true,
            }
          )
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            self.$emit(
              "siteAlertSuccess",
              self.getString("Servizio eliminato.")
            );
            self.prices = response.data.data.prices;
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          })
          .finally(() => {
            self.isLoading = false;
          });
      }
    },
    resetPrice: function () {
      this.editTime = false;
      this.getPrices();
    },
    updatePrice: function () {
      let self = this;
      this.isLoading = true;
      if (self.shopID > 0) {
        ajax.axios
          .put(
            ajax.baseUrl() + "/admin/shops/shop/" + self.shopID + "/prices/",
            { Prices: self.prices, Categories: self.categories },
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true,
            }
          )
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            self.$emit(
              "siteAlertSuccess",
              self.getString("Servizi aggiornati.")
            );
            self.editTime = false;
            self.isLoading = false;
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
            self.isLoading = false;
          });
      }
    },
    updateSort: function (e) {
      this.isLoading = true;
      let old = e.oldIndex;
      let newI = e.newIndex;
      if (old < newI) {
        for (let i = old + 1; i <= newI; i++) {
          if (old <= this.prices.length) this.prices[i].sort = i;
        }
      }
      if (old > newI) {
        for (let i = newI - 1; i <= old; i++) {
          if (i >= 0) this.prices[i].sort = i;
        }
      }

      let data = { Prices: this.prices, Categories: this.categories };
      let self = this;
      ajax.axios
        .put(
          ajax.baseUrl() + "/admin/shops/shop/" + self.shopID + "/prices",
          data,
          {
            headers: {
              Authorization: "Bearer " + self.$store.getters.token,
            },
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.isLoading = false;
          self.$emit("siteAlertSuccess", self.getString("Aggiornato"));
        })
        .catch(function (error) {
          self.isLoading = false;
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    categoriesSort: function (e) {
      this.isLoading = true;
      let old = e.oldIndex;
      let newI = e.newIndex;

      if (old < newI) {
        for (let i = old + 1; i <= newI; i++) {
          if (old <= this.categories.length) this.categories[i].sort = i;
        }
      }

      if (old > newI) {
        for (let i = newI - 1; i <= old; i++) {
          if (i >= 0) {
            this.categories[i].sort = i;
            console.log(this.categories);
            console.log(i);
          }
        }
      }

      let data = { Prices: this.prices, Categories: this.categories };
      console.log(this.categories);
      let self = this;
      ajax.axios
        .put(
          ajax.baseUrl() + "/admin/shops/shop/" + self.shopID + "/prices",
          data,
          {
            headers: {
              Authorization: "Bearer " + self.$store.getters.token,
            },
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.isLoading = false;
          self.$emit("siteAlertSuccess", self.getString("Aggiornato"));
        })
        .catch(function (error) {
          self.isLoading = false;
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    qrCode: function () {
      this.qrcodeDialog = true;
    },
    test: function () {
      this.$emit("siteAlert", "Hello!");
    },
    getString: function (key) {
      let page = this.$store.state.currentTranslator.getString(key);
      return page;
    },
    getPrices: function () {
      let self = this;
      if (self.shopID > 0) {
        ajax.axios
          .get(
            ajax.baseUrl() + "/admin/shops/shop/" + self.shopID + "/prices",
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true,
            }
          )
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            self.prices = response.data.data.prices;
            self.categories = response.data.data.categories;
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          });
      }
    },
    getShop: function () {
      let self = this;
      this.shop.name = null;
      if (self.shopID > 0) {
        ajax.axios
          .get(ajax.baseUrl() + "/admin/shops/shop/" + self.shopID, {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true,
          })
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            self.shop = response.data.data;
            self.oldShop.serviceNote = self.shop.serviceNote;
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
            setTimeout(function () {
              location.href = "/admin/dashboard";
            }, 3000);
          });
      }
    },
    sourceSet: function (name, type, size) {
      this.imageName = this.$refs.fileToUpload.$refs.fileinput.files[0].name;
    },
    sourceLogoSet: function (name, type, size) {
      this.logoName = this.$refs.logoToUpload.$refs.fileinput.files[0].name;
    },
    setShop: async function () {
      if (this.saveAlert) {
        this.isLoading = true
        let self = this;
        var data = new FormData();

        if (this.shop.serviceNote !== null)
          data.append("serviceNote", this.shop.serviceNote);

        ajax.axios
          .put(ajax.baseUrl() + "/admin/shops/shop/" + self.shopID, data, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + self.$store.getters.token,
            },
            withCredentials: true,
          })
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            self.$emit("siteAlertSuccess", response.data.data.text);
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          }).
          finally(() => {
            self.isLoading = false;
          });
          
      }
      // else {
      //   this.$emit("siteAlert", this.getString("Nessuna modifica richiesta"));
      // }
    },
  },
};
</script>

<style scoped>
.formDesc {
  align-items: center;
  margin-bottom: 20px;
}
.formDesc label,
.formDesc v-text-field {
  margin: 10px;
}

.icon-button {
  height: 50px;
  width: 50px;
  background: white;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}
.pricesElements {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  text-align: center;
  gap: 8px;
}

.pricesElements span {
  flex-grow: 1;
  padding: 10px;
}

.pricesElements .desc {
  flex-grow: 3;
  width: 40%;
  text-align: left;
}

.pricesElements .fulldesc {
  flex-grow: 3;
  width: 80%;
  text-align: left;
}

.edit-field {
  margin: 4px 0;
}

.avatar-img {
  position: relative;
  width: 100%;
  max-height: 430px;
  object-fit: cover;
  transition: max-height 0.3s ease-in-out;
}

/* .avatar-img:hover {
  max-height: 1000px;
} */

.save-alert {
  animation-name: saveAlertAnimation !important;
  animation-timing-function: linear !important;
  animation-duration: 1s !important;
  animation-iteration-count: infinite !important;
}

.img-badge {
  width: 70px;
  position: absolute;
  top: 5px;
  right: 5px;
}
.wrapper-logo {
  position: absolute;
  bottom: 0;
  text-align: center;
  background: white;
  border-radius: 50%;
  overflow: hidden;
  border: solid lightgrey 2px;
  height: 125px;
  width: 125px;
  cursor: pointer;
}
.img-logo {
  width: 100%;
}

@keyframes saveAlertAnimation {
  0% {
    background-color: transparent;
  }

  50% {
    background-color: orange;
  }

  100% {
    background-color: transparent;
  }
}

.service-mobile-card .v-card__text {
  padding: 8px 12px !important;
}

.service-mobile__row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.service-mobile__info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.service-mobile__name {
  font-weight: 500;
  font-size: 15px;
  line-height: 1.4;
}

.service-mobile__fulldesc {
  font-size: 13px;
  opacity: 0.65;
  line-height: 1.3;
}

.service-mobile__footer {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  flex-wrap: wrap;
}

.service-mobile__meta {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.6);
}

.service-mobile__input {
  max-width: 85px;
}
.service-mobile__handle {
  flex-shrink: 0;
  cursor: move;
  color: rgba(0, 0, 0, 0.35);
  margin-right: 4px;
  touch-action: none;
}

/* Mobile icon size fix */
.service-mobile__icon-wrap {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/pieces/ShopServices.vue